import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { Quote } from './quote';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('quote', {
    _component: () => Quote,
  }, overrideReadOnly);
